export const parseEmails = (emails: string) => {
  return emails
    .split(",")
    .map((v) => v.trim())
    .filter((v) => v.length > 0);
};
